import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ShopPage } from "../../pages/shop/shop";
import { NavController, NavParams } from "ionic-angular";
import { HttpClient } from "@angular/common/http";
import { ApiErrorHandlerProvider } from "../../providers/api-error-handler/api-error-handler";
import { DurationPipe } from "../../pipes/duration/duration";
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { CoffeShopPage } from '../../pages/coffe-shop/coffe-shop';

/**
 * Generated class for the ShopLocationsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'shop-locations',
    templateUrl: 'shop-locations.html'
})
export class ShopLocationsComponent {

    @Input() shop: any;
    @Input() shopType: '1' | '0'; // 1 = Coffe Shop , 0 = Barber Shop
    @Output() routingToPage = new EventEmitter();
    errors: {};
    loading: boolean;
    shops: any;
    noShopLocations: boolean;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private http: HttpClient,
        private apiErrorHandler: ApiErrorHandlerProvider,
        public durationPipe: DurationPipe) {
        this.shop = navParams.get('shop');
        this.noShopLocations = false;
    }

    ngOnInit() {
        this.loading = true;
        this.getLocations(this.shop).then((locations: any[]) => {
            this.getShopQueueTime(locations);
            this.loading = false;
        })
    }

    openPage(event: any, shop: any): void {
        if (shop && shop.settings && shop.settings.shop_type === 1) {
            this.routingToPage.emit(true);
            this.navCtrl.push(CoffeShopPage, {
                shopId: shop.id
            });
            setTimeout(() => {
                this.navCtrl.remove(this.navCtrl.last().index - 1, 1);
            }, 100);
            return
        }
        this.navCtrl.push(ShopPage, {
            shop: shop
        });
    }

    getLocations(shop) {
        return new Promise((resolve, reject) => {
            this.http.get(`/teams/${this.shop.owner_id}/location`)
                .pipe(switchMap((locations: any[]) => of(locations.filter((location) => location.settings && location.settings.shop_type === this.shopType && location.id !== this.shop.id))))
                .subscribe((locations: any) => {
                    this.shop = shop;
                    this.shop.locations = locations;
                    return resolve(locations);
                }, error => {
                    this.errors = this.apiErrorHandler.handleError(error);
                    return reject();
                }, () => {

                });
        });
    }

    getShopQueueTime(shops) {

        // Iterate over each shop and make an api request to get the current queue time
        shops.forEach(shop => {
            this.http.get(`/teams/${shop.id}/queue`)
                .subscribe((response: any) => {
                    shop.queue = response;
                });
        });

    }

    ngOnChanges(changes) {
        this.loading = true;
        if (changes.shop) {
            this.shop = changes.shop.currentValue;
            if (this.shop.users) {
                this.getLocations(this.shop).then(locations => {
                    this.getShopQueueTime(locations);
                    this.loading = false;
                });
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/components/shop-locations/shop-locations.ts